import { Typography } from "@mui/material";
import { ArrowRightAltRounded, MenuBookRounded, MonetizationOnRounded } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { useContext } from "react";
import { ConfidentialsContext, SidebarStates } from "../../constants";
import { logClickEvent } from "../../analytics";
import { AppDispatch } from "../../redux/store";
import { showPromo } from "../../redux/slices/IntroPromoSlice";

const promoToRender = {
  [SidebarStates.Intro]: {
    icon: <MonetizationOnRounded className="w-5 h-5 text-tgpt-secondary-dark" />,
    title: "Intro to TradeGPT",
    subtitle: "Boost your trading profits with our FREE training.",
    onClick: () => {
      logClickEvent("tgpt_intro_click");
    },
  },
  [SidebarStates.Prompt]: {
    icon: <MenuBookRounded className="w-5 h-5 text-tgpt-secondary-dark" />,
    title: "1000+ Prompts",
    subtitle: "Boost your trading profits with our FREE training.",

  },
};

const SidebarPromoItem = () => {
  const { sidebarState } = useContext(ConfidentialsContext);

  const dispatch = useDispatch<AppDispatch>();
  const content = promoToRender[sidebarState];
  return (
    <div
      onClick={() => dispatch(showPromo())}
      className="flex items-center h-[96px] cursor-pointer p-4 bg-tgpt-secondary-accentLight hover:bg-tgpt-secondary-states-hover rounded-[4px]"
    >
      <div className="flex flex-col gap-y-1">
        <div className="flex gap-x-2 items-center">
          {content.icon}
          <Typography variant="body2/regular-400" className="font-semibold text-tgpt-secondary-dark">
            {content.title}
          </Typography>
        </div>
        <Typography variant="caption/regular-400" className="text-left text-token-text-secondary">
          {content.subtitle}
        </Typography>
      </div>
      <ArrowRightAltRounded className="w-5 h-5 text-action-active" />
    </div>
  );
};

export default SidebarPromoItem;
